import client from '@/services/';

const state = () => ({
    all: [],
    one: {},
    fichier: [],

});

const getters = {
    all: state => state.all,
    one: state => state.one,
    fichier: state => state.fichier,

};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
    SET_FICHIER: (state, obj) => {
        state.fichier = obj;
    },
};

const actions = {
    async getAllP({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '', titre = '', resume = '', publie = '', debAfter = '', debBefore = ''} = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            titre,
            resume,
            publie,
            debAfter,
            debBefore
        }).toString();
        let data = await client.get('actualites?' + queryParams);
        commit("SET_ALL", data.data);
        return data.data;
    },
    async getOne(cxt, id) {
        let data = await client.get('actualites/one/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async create(cxt, payload) {
        let { data } = payload.id ? await client.put('actualites/' + payload.id, payload) : await client.post('actualites/add', payload);
        cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }

        return data;
    },
    async del(cxt, id) {
        let { data } = await client.delete('actualites/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async uploadImage({ commit }, { payload }) {
        try {
            const data = await client.post('fichier/add/simple', payload, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            commit('SET_FICHIER', data);
            return data;

        } catch (error) {
            console.error('Erreur lors de l\'ajout du document :', error);
            throw error;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
